<template>
  <div class="container sv024">
    <breadcrumb-group :items="breadcrumbItems"/>

    <heading-one>au PAY 残高にチャージ（お借り入れ）</heading-one>

    <p class="_mb-md-60 _mb-sm-40">au PAY 残高にそのままチャージができます。チャージした残高は、au PAY プリペイドカードやau PAYで全国のコンビニ・スーパーやMastercard®加盟店、au PAY加盟店などいろいろな場所で使え、お買い物200円（税込）ごとに１Pontaポイントたまります。さらに、au PAY プリペイドカードなら「ポイントアップ店」で利用すると、通常よりもPontaポイントがたまっておトクです。</p>

    <section>
      <step-list type="sv" class="_mb-md-60 _mb-sm-20 -orange">
        <heading-two>au PAY 残高へのチャージ方法</heading-two>
        <step-item number="1" title="会員さま専用サイトへログイン" src="sv/sv024/img01.jpg" src-sp="sv/sv024/sp/img01.jpg">
          <p>会員さま専用サイトへログインします。</p>
          <list-group class="-note">
            <list-item class="-note">au PAY スマートローンアプリでもお手続きが可能です。</list-item>
          </list-group>
          <btn-main class="-normal" routerName="ce001">
            会員さま専用サイトトップへ
          </btn-main>
          <!--<list-group class="-link _mt-md-20">-->
            <!--<list-item class="-link" routerName="mb001">会員さま専用サイトへ</list-item>-->
          <!--</list-group>-->
        </step-item>
        <step-item number="2" title="「au PAY 残高にチャージ」を選択" src="sv/sv024/img02.jpg" src-sp="sv/sv024/sp/img02.jpg">
          <p>会員さま専用サイトのお借り入れメニュー内より「au PAY 残高にチャージ」を選択してください。</p>
        </step-item>
        <step-item number="3" title="お借り入れ金額をご入力のうえ「お申し込み」を押下" src="sv/sv024/img03.jpg" src-sp="sv/sv024/sp/img03.jpg" class="-last">
          <p>暗証番号認証後、お借り入れ金額をご入力のうえ、確認画面に進み「お申し込み」ボタンを押してください。</p>
        </step-item>
        <step-footer>
          <template slot="heading">お手続き完了</template>
          <template slot="text">
            <p class="_mt-15">お手続き完了後、すぐにau PAY 残高にチャージいたします。<br>チャージした残高は、au PAY プリペイドカードやau PAYでお買い物にご利用いただけます。</p>
          </template>
        </step-footer>
      </step-list>
      <list-group class="-note">
        <list-item class="-note">チャージ手数料はかかりません。</list-item>
        <list-item class="-note">以下の場合はご利用いただけません。</list-item>
      </list-group>
      <list-group class="-normal">
        <list-item class="-normal">お手持ちのau PAY プリペイドカードとau PAY スマートローンのご登録名義が異なる場合</list-item>
        <list-item class="-normal">au PAY 残高のチャージ上限額を超える場合</list-item>
        <list-item class="-normal">システムメンテナンス時間帯など</list-item>
      </list-group>
    </section>

    <section>
      <heading-two>au PAY 残高について</heading-two>
      <div class="_mb-md-120 _mb-sm-60">
        <div class="txt-box">
          <list-group>
            <list-item>チャージした残高は、au PAYでご利用いただけます。<br>詳しくは以下のサイトをご確認ください。</list-item>
          </list-group>
          <list-group class="-linkclass">
            <list-item href="https://aupay.wallet.auone.jp/" target="_blank" class="-link">
              <heading-icon class="-left _mb-0">
                au PAYについて<icon-box src="out" class="-xs _ml-5"></icon-box>
              </heading-icon>
            </list-item>
          </list-group>
          <list-group>
            <list-item>au PAY プリペイドカードでau PAY 残高をご利用いただくには、別途お申し込みが必要となります。<br>詳しくは以下のサイトをご確認ください。</list-item>
          </list-group>
          <list-group class="-link _mb-md-50 _mb-sm-40">
            <list-item href="https://wallet.auone.jp/contents/pc/first/" target="_blank" class="-link">
              <heading-icon class="-left _mb-0">
                au PAY プリペイドカードについて<icon-box src="out" class="-xs _ml-5"></icon-box>
              </heading-icon>
            </list-item>
          </list-group>
        </div>
      </div>
    </section>

    <cv-box class="_mb-md-120 _mb-sm-60"/>

    <contact-box class="_mb-md-120 _mb-sm-60"/>

  </div><!-- container -->
</template>

<script>
import HeadingOne from '../components/heading/HeadingOne'
import HeadingTwo from '../components/heading/HeadingTwo'
import StepList from '../components/steps/StepList'
import StepItem from '../components/steps/StepItem'
import StepFooter from '../components/steps/StepFooter'
import ListGroup from '../components/list/ListGroup'
import ListItem from '../components/list/ListItem'
import BtnMain from '../components/button/BtnMain'
import BtngroupSingle from '../components/button/BtngroupSingle'
import TableBox from '../components/tables/TableBox'
import TableBody from '../components/tables/TableBody'
import TableRow from '../components/tables/TableRow'
import TableHeader from '../components/tables/TableHeader'
import TableData from '../components/tables/TableData'
import CvBox from '../components/box/CvBox'
import CardBox from '../components/card/CardBox'
import CardHeader from '../components/card/CardHeader'
import CardBody from '../components/card/CardBody'
import ContactBox from '../components/box/ContactBox'
import IconBox from '../components/icons/icon-box'
import HeadingIcon from '../components/heading/HeadingIcon'

export default {
  name: 'Sv-024',
  metaInfo: {
    title: 'au PAY 残高にチャージ｜お借り入れ方法',
    meta: [
      {name: 'description', content: 'au PAY 残高へのチャージによるお借り入れ方法をご案内します。au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。'},
      {name: 'keywords', content: 'au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,au PAY 残高,チャージ'}
    ]
  },
  components: {
    HeadingIcon,
    IconBox,
    ContactBox,
    CardBody,
    CardHeader,
    CardBox,
    CvBox,
    TableData,
    TableHeader,
    TableRow,
    TableBody,
    TableBox,
    BtngroupSingle,
    BtnMain,
    ListItem,
    ListGroup,
    StepFooter,
    StepItem,
    StepList,
    HeadingOne,
    HeadingTwo
  },
  data () {
    return {
      breadcrumbItems: [{
        text: 'トップ',
        routerName: 'root'
      },
      {
        text: 'お借り入れについて',
        routerName: 'sv046'
      },
      {
        text: 'au PAY 残高にチャージ',
        active: true
      }]
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../assets/stylesheets/styles";
</style>



// WEBPACK FOOTER //
// src/pages/Sv024.vue